<nav class="custom_breadcumbs">
    <ol>
        <li *ngFor="let item of breadCampsList" class="{{item.className}}">
            <a>{{item.name}}</a>
        </li>
    </ol>
</nav>